import { View, Text, Image } from '@react-pdf/renderer'
import moment from 'moment'
import { ISharedDiagnosticReport } from '../../../types/diagnostics'
import Logo from '../../../assets/Logo.png'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const Header = ({ reportData }: { reportData: ISharedDiagnosticReport }) => {
  const { t } = useTranslation()

  return (
    <View style={styles.headerContainer}>
      <View style={styles.logoContainer}>
        <Image src={Logo} style={styles.logo} />
      </View>
      <Text style={styles.title}>{t('sharedDiagnostic.report.title')}</Text>
      <Text style={styles.subtitle}>
        {t('shared.common.createdAt')}{' '}
        {moment(reportData.createdAt).format('DD/MM/YYYY')}{' '}
        {t('shared.common.for')} {reportData.patient?.firstName}{' '}
        {reportData.patient?.lastName.toUpperCase()}
      </Text>
    </View>
  )
}

export default Header
